/* eslint-disable react-hooks/exhaustive-deps */
/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-07-19 11:39:10
 *
 *******************************************************/
// @flow
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { withI18n } from '@shopify/react-i18n';
import { connect } from 'react-redux';
import { Heading, Layout, Subheading, Button, Card, Grid, Icon } from '@shopify/polaris';
import { LockMinor } from '@shopify/polaris-icons';

import { exitSABFullscreen } from 'src/integrations/shopify-app-bridge/fullscreen';

import ProcessAddon from 'src/components/views/subscription-v3/addon/process-addon';

import history from 'src/routes/history';
import { routes } from 'src/routes';

import { ADDONS_INFO, AI_POWERED_RECOMMENDATION_NAME } from 'src/constants/subscription';

import RecommendationPersonalization from 'src/assets/images/landing-page/ai-powered/recommendation-personalization.png';
import RecommendationFrequentlyBoughtTogether from 'src/assets/images/landing-page/ai-powered/recommendation-frequently-bought-together.png';
import RecommendationRelatedItems from 'src/assets/images/landing-page/ai-powered/recommendation-related-items.png';

import * as subscriptionV3Actions from 'src/stores/actions/subscription-v3-actions';
import { handleOpenFullscreen } from 'actions/app-integration-actions';

const AIRecommendation = props => {
  const [modalAddon, setModalAddon] = useState(false);
  const [addonStatus, setAddonStatus] = useState({});

  const {
    i18n,
    handleOpenFullscreen,
    getAddonStatus,
    notAllowAddon,
    statusStore,
    enableAIRecommendation
  } = props;

  // Use effect - Before render page
  useEffect(() => {
    // Get current status addon sync
    getAddonStatus(AI_POWERED_RECOMMENDATION_NAME).then(response => {
      const { type = '', payload = {} } = response;
      const { data = {} } = payload;
      if (type === 'GET_ADDON_STATUS_SUCCESS') {
        setAddonStatus(data);
      }
    });
  }, []);

  const handleUnlock = () => {
    if (notAllowAddon) {
      history.push(routes.subscription.plan());
    } else {
      setModalAddon(!modalAddon);
    }
  };

  const handleExplorer = () => {
    history.push(routes.recommendationWidgets.list());
    exitSABFullscreen();
    handleOpenFullscreen(false);
  };

  const addonRemainingCycles = _.get(addonStatus, 'trialInfo.remainingDays', 14);
  const isSubscribeNow =
    !['trial', 'expiredSoon'].includes(statusStore) && addonRemainingCycles <= 0;

  return (
    <Layout.Section>
      <div className="section-header">
        <Heading>{i18n.translate('AdminHTML.LandingPage.AIPowered.recommendation_Title')}</Heading>
        <Subheading>
          {i18n.translate('AdminHTML.LandingPage.AIPowered.recommendation_SubTitle')}
        </Subheading>
        {enableAIRecommendation ? (
          <Button onClick={handleExplorer}>
            {i18n.translate(`AdminHTML.LandingPage.AIPowered.btn_Explore`)}
          </Button>
        ) : (
          <div className={`Polaris-Button button-unlock`} onClick={handleUnlock}>
            <Icon source={LockMinor} />
            {i18n.translate(
              `AdminHTML.LandingPage.AIPowered.${
                isSubscribeNow || notAllowAddon ? 'btn_Unlock' : 'btn_UnlockTrial'
              }`
            )}
          </div>
        )}
      </div>
      <div className="section-content recommendation-blocks">
        <Grid columns={{ xs: 1 }}>
          <Grid.Cell columnSpan={{ xs: 12, sm: 4, md: 4, lg: 4, xl: 4 }}>
            <Card>
              <img
                className="full-width"
                src={RecommendationPersonalization}
                alt={i18n.translate(
                  'AdminHTML.LandingPage.AIPowered.recommendation_Block01_Banner01_Title'
                )}
              />
              <div className="card-content">
                <p className="title">
                  {i18n.translate(
                    'AdminHTML.LandingPage.AIPowered.recommendation_Block01_Banner01_Title'
                  )}
                </p>
                <p className="content">
                  {i18n.translate(
                    'AdminHTML.LandingPage.AIPowered.recommendation_Block01_Banner01_Content'
                  )}
                </p>
              </div>
            </Card>
          </Grid.Cell>
          <Grid.Cell columnSpan={{ xs: 12, sm: 4, md: 4, lg: 4, xl: 4 }}>
            <Card>
              <img
                className="full-width"
                src={RecommendationFrequentlyBoughtTogether}
                alt={i18n.translate(
                  'AdminHTML.LandingPage.AIPowered.recommendation_Block01_Banner02_Title'
                )}
              />
              <div className="card-content">
                <p className="title">
                  {i18n.translate(
                    'AdminHTML.LandingPage.AIPowered.recommendation_Block01_Banner02_Title'
                  )}
                </p>
                <p className="content">
                  {i18n.translate(
                    'AdminHTML.LandingPage.AIPowered.recommendation_Block01_Banner02_Content'
                  )}
                </p>
              </div>
            </Card>
          </Grid.Cell>
          <Grid.Cell columnSpan={{ xs: 12, sm: 4, md: 4, lg: 4, xl: 4 }}>
            <Card>
              <img
                className="full-width"
                src={RecommendationRelatedItems}
                alt={i18n.translate(
                  'AdminHTML.LandingPage.AIPowered.recommendation_Block01_Banner03_Title'
                )}
              />
              <div className="card-content">
                <p className="title">
                  {i18n.translate(
                    'AdminHTML.LandingPage.AIPowered.recommendation_Block01_Banner03_Title'
                  )}
                </p>
                <p className="content">
                  {i18n.translate(
                    'AdminHTML.LandingPage.AIPowered.recommendation_Block01_Banner03_Content'
                  )}
                </p>
              </div>
            </Card>
          </Grid.Cell>
        </Grid>
      </div>
      {/* Process addon unlock */}
      <ProcessAddon
        openModalReview={modalAddon}
        addon={ADDONS_INFO.find(e => e.addonName === AI_POWERED_RECOMMENDATION_NAME)}
        hadSubscribed={isSubscribeNow}
        handleAfterSubscribeAddon={handleExplorer}
        handleReviewModal={() => setModalAddon(!modalAddon)}
      />
    </Layout.Section>
  );
};
const mapDispatchToProps = (dispatch, ownProps) => ({
  getAddonStatus: addonName => dispatch(subscriptionV3Actions.getAddonStatus(addonName)),
  handleOpenFullscreen: (isOpenFullScreen: boolean) =>
    dispatch(handleOpenFullscreen(isOpenFullScreen))
});

const mapStateToProps = (state, props) => {
  return {
    notAllowAddon: _.get(state.oauth, 'subscription.notAllowAddon', false),
    statusStore: _.get(state.oauth, 'subscription.status', ''),
    enableAIRecommendation: _.get(
      state.oauth.tenantApp,
      'settings.recommendation.settings.frequently-bought-together',
      false
    )
  };
};

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(AIRecommendation));
